import React, { useCallback, useState, useMemo } from 'react'
import Tabs from '@groovehq/internal-design-system/lib/components/Tabs/Tabs'
import { divider } from '@groovehq/internal-design-system/lib/styles/elements'

const Tabbed = ({ tabsData, defaultTab, ...rest }) => {
  const [activeTabKey, setActiveTabKey] = useState(defaultTab)

  const ActivePanel = useMemo(
    () => tabsData.find(t => t.key === activeTabKey).component,
    [tabsData, activeTabKey]
  )

  const handleTabKeyChange = useCallback(
    key => {
      if (key === activeTabKey) return
      setActiveTabKey(key)
    },
    [activeTabKey]
  )

  return (
    <div className="grui mb-10">
      <Tabs
        activeKey={activeTabKey}
        tabs={tabsData}
        type="small"
        onChange={handleTabKeyChange}
        className="grui mb-5"
      />
      <div css={divider.styles.base} role="separator" />
      <ActivePanel {...rest} />
    </div>
  )
}

export default Tabbed
